import React from "react";
import styles from "./styles.css";
var AdContainerDesktop = function AdContainerDesktop(_ref) {
  var id = _ref.id,
    page = _ref.page;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles.adContainerDesktop, " ad-container-desktop")
  }, /*#__PURE__*/React.createElement("div", {
    className: "flexible ad-container",
    "data-ad-container": true,
    "data-ad-viewport": "desktop"
  }, /*#__PURE__*/React.createElement("div", {
    id: "ad-".concat(id),
    className: "ad-slot",
    "data-ad-selector": "ad-".concat(id),
    "data-ad-position": "728top",
    "data-ad-page": page,
    "data-ad-sizes": "[[728, 90]]",
    "data-ad-mobile-sizes": "",
    "data-ad-desktop-sizes": "[[728, 90]]"
  })));
};
export default AdContainerDesktop;